export const HTTP_STATUS = {
	UNAUTHORIZED: 401,
} as const;

export const API_ERROR_MESSAGES = {
	JWT_EXPIRED: "Jwt is expired",
} as const;

export const CHECKOUT_ERROR_TYPES = {
	OOS_ERROR: "OOS_ERROR",
} as const;
